export const type = 'form.altcha';
